import { Link, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export function PublicNav() {
  const { user, hasAccess, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-muted-foreground">
          <a href="/#demo" data-testid="nav-demo-link" className="hover:text-foreground transition-colors">Demo question</a>
          <a href="/#topics" data-testid="nav-topics-link" className="hover:text-foreground transition-colors">Topics</a>
          <Link to="/pricing" data-testid="nav-pricing-link" className="hover:text-foreground transition-colors">Pricing</Link>
          <a href="/#faq" data-testid="nav-faq-link" className="hover:text-foreground transition-colors">FAQ</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {isAdmin && (
                <Button variant="outline" size="sm" data-testid="nav-admin-btn" onClick={() => navigate("/admin")}>Admin</Button>
              )}
              <Button variant="outline" size="sm" data-testid="nav-dashboard-btn"
                onClick={() => navigate(hasAccess ? "/app" : "/pricing")}>
                {hasAccess ? "Dashboard" : "Subscribe"}
              </Button>
              <Button variant="ghost" size="sm" data-testid="nav-logout-btn" onClick={async () => { await logout(); navigate("/"); }}>
                Log out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-login-btn" onClick={() => navigate("/login")}>Log in</Button>
              <Button size="sm" data-testid="nav-signup-btn" onClick={() => navigate("/register")}>Sign up</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo dark />
          <p className="mt-4 text-sm text-primary-foreground/70 max-w-md leading-relaxed">
            The UK Physician Associate question bank. PA-specific SBA practice designed around UK PA education and PARA preparation.
          </p>
          <p className="mt-6 text-xs text-primary-foreground/50 leading-relaxed max-w-md">
            PAMind is an independent educational resource and is not affiliated with or endorsed by the Faculty of Physician Associates, Royal College of Physicians, General Medical Council or any UK university. Content is designed to support preparation for UK PA university assessments and the PARA.
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-primary-foreground/60 mb-4">Product</h4>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#demo" data-testid="footer-demo-link" className="hover:text-accent transition-colors">Demo question</a></li>
            <li><Link to="/pricing" data-testid="footer-pricing-link" className="hover:text-accent transition-colors">Pricing</Link></li>
            <li><Link to="/register" data-testid="footer-signup-link" className="hover:text-accent transition-colors">Create account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-primary-foreground/60 mb-4">Legal</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/legal/privacy" data-testid="footer-privacy-link" className="hover:text-accent transition-colors">Privacy policy</Link></li>
            <li><Link to="/legal/terms" data-testid="footer-terms-link" className="hover:text-accent transition-colors">Terms &amp; conditions</Link></li>
            <li><Link to="/legal/cookies" data-testid="footer-cookies-link" className="hover:text-accent transition-colors">Cookie policy</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-accent transition-colors">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 text-xs text-primary-foreground/50">
          © {new Date().getFullYear()} PAMind. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
